import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {MySortButtonStatesEnum} from '../../../../enums/my-sort-button-states.enum';
import {ModalVisibilityService} from '../../../../services/modal-visibility.service';
import {IProjectService} from '../../../../services/project.service.interface';
import {EditModalService} from '../../../../services/edit-modal.service';
import {MyProjectsTableRowActionEnum} from '../../../../enums/my-project-table-row-action.enum';
import {ProjectModel} from '../../../../models/project.model';
import {ProjectIsLockedModalComponent} from '../../../project-is-locked-modal/project-is-locked-modal.component';
import {ProjectsApprovalListItemModel} from '../../../../models/projects-approval-list-item.model';
import {SummaryModalComponent} from '../../../summary-modal/summary-modal.component';
import {MyPriceApprovalModeEnum} from '../../../../enums/my-price-approval-mode.enum';
import {Router} from '@angular/router';
import {ProjectTablesBase} from '../../project-tables-base';
import {ModalDynamicV3Service} from '../../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
  selector: 'app-filtered-price-approval-project-table',
  templateUrl: './filtered-price-approval-project-table.component.html',
  styleUrls: ['./filtered-price-approval-project-table.component.scss']
})
export class FilteredPriceApprovalProjectTableComponent extends ProjectTablesBase implements OnChanges {

    @Input() public projects: ProjectsApprovalListItemModel[];
    @Input() public isProcessedModeUsed = false;  // if the table is used for second tab 'Bearbeitete Projekte / Processed projects'

    @Output() public projectsChangedNotification: EventEmitter<void> = new EventEmitter();

    public tableProjects: ProjectsApprovalListItemModel[];
    private lastMenuActionIsFinished = true;


    private defaultSortingData: { property: string, sortOrder: MySortButtonStatesEnum } = {
        property: 'quoteClosingDate',
        sortOrder: MySortButtonStatesEnum.DESCENT
    };
    private sortingData: { property: string, sortOrder: MySortButtonStatesEnum } = this.defaultSortingData;




    // define which projects the table is working with
    @Input() public tableProjectFilterFn: Function = (project) => {
        return true;
        // tslint:disable-next-line
    };

    constructor(
        private modalVisibilityService: ModalVisibilityService,
        private modalDynamicV3Service: ModalDynamicV3Service,
        private projectService: IProjectService,
        private editModalService: EditModalService,
        private router: Router) {
        super();
    }



    ngOnChanges(changes: SimpleChanges): void {
        this.tableProjects = this.projects && this.projects.filter(project => this.tableProjectFilterFn(project));
        this.sortTable();
    }

    // table buttons  =============

    public onTableSortBtnClicked($event: { columnId: string; state: MySortButtonStatesEnum }) {
        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        if ($event.state === MySortButtonStatesEnum.DISABLED) {
            this.sortingData = null;
            this.sortTable();
        } else {
            // $event.columnId contains property name to sort by, lets use it to initialize sortingData:
            this.sortingData = {property: $event.columnId, sortOrder: $event.state};
            this.sortTable();
        }
    }


    private sortTable() {

        if (!this.tableProjects) {
            return;
        }

        // if (!this.sortingData) {
        //     // default/initial order will be used
        //     this.sortingData = {property: 'rolloutStart', sortOrder: MySortButtonStatesEnum.DESCENT};
        // }

        this.sortTableBySortingData(this.tableProjects, this.sortingData);
    }



    public async onProjectTableRowActionsMenuClicked(model: {
        projectsListItem: ProjectsApprovalListItemModel;
        actionId: MyProjectsTableRowActionEnum
    }): Promise<void> {
        // console.log('onProjectTableRowActionsMenuClicked', model);
        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
        if (this.lastMenuActionIsFinished && !this.editModalService.isDialogOpened) {
            this.lastMenuActionIsFinished = false;


            let dialogRef: IModalDialogV3;

            switch (model.actionId) {
                case MyProjectsTableRowActionEnum.PRICE_APPROVAL:
                case MyProjectsTableRowActionEnum.PRICE_APPROVAL_TABLE_PROJECT_NAME_LINK_CLICKED:
                    // console.log('PRICE_APPROVAL [fpap]');


                    let project: ProjectModel;
                    try {
                        project = await this.projectService.getProject(model.projectsListItem.id);



                        dialogRef = this.modalDynamicV3Service
                            .open(SummaryModalComponent, {
                                model: {project: project,  usePriceApprovalMode: MyPriceApprovalModeEnum.ACTIVE }
                            });
                        dialogRef.subscribe(async (val) => {
                            // await this.editModalService.handleSummaryModalResult(val, dialogRef);
                            this.reloadTableContent();
                        });

                    } catch (e) {

                        if (e.status === 500) {
                            return;  // do nothing, error message is already shown via interceptor
                        }

                        dialogRef = this.modalDynamicV3Service
                            .open(ProjectIsLockedModalComponent, {
                                model: {
                                    ... this.editModalService.translateAndTransformToErrMessageObj(e)
                                }
                            });

                        // project is locked, so reload full table
                        // or only update current row lock status to avoid loosing current row focus
                        this.reloadTableContent();
                        console.error(e);
                    }
                    break;
                case MyProjectsTableRowActionEnum.TCO_CALCULATION:

                    await this.router.navigate(['projects-tco/data/' + model.projectsListItem.id]);
                    break;
                default:
                    console.error('unexpected actionID ', model.actionId);

            }

            this.lastMenuActionIsFinished = true;
        }
    }




    private async reloadTableContent() {
        // console.log('=====   project list for main table will be reloaded...');
        this.projectsChangedNotification.next();
        // project list table will be reloaded via onChanged method after projects input variable will be changed
    }

}
